import { Component, Input, OnInit, OnDestroy, signal } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatFabButton } from '@angular/material/button';
import { AsyncPipe, NgClass } from '@angular/common';
import { Notice } from '../../../models/notice';
import { MatCard } from '@angular/material/card';
import { NoticeLevelEnum } from '../../../enum/notice-level.enum';
import { IconEnum } from '../../../enum/icon.enum';

@Component({
    selector: 'app-context-notices',
    templateUrl: './context-notices.component.html',
    imports: [
        IconComponent,
        MatFabButton,
        AsyncPipe,
        MatCard,
        NgClass
    ],
    styleUrls: [ './context-notices.component.scss' ]
})
export class ContextNoticesComponent implements OnInit, OnDestroy {
    @Input({ required: true }) notices$!: Observable<Notice[]>;

    /** Tracks open/closed state of the floating panel */
    readonly isOpen = signal<boolean>(false);

    /** Tracks currently expanded notice (if any) */
    readonly expandedNotice = signal<Notice | null>(null);

    /** Subscription for auto-open detection */
    private sub?: Subscription;

    ngOnInit(): void {
        let previousCount = 0;
        this.sub = this.notices$.subscribe((notices: Notice[]) => {
            const currentCount = notices?.length ?? 0;
            if (currentCount > previousCount) {
                // auto-open on new notice
                this.isOpen.set(true);
            }
            previousCount = currentCount;
        });
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    /** Toggle the open/closed state */
    toggleOpen(): void {
        this.isOpen.update((v) => !v);
    }

    /** Expand a specific notice into full view */
    expand(notice: Notice): void {
        this.expandedNotice.set(notice);
    }

    /** Close the expanded view */
    closeExpanded(): void {
        this.expandedNotice.set(null);
    }

    noticeClass(notice: Notice): string {
        switch (notice.level) {
            case NoticeLevelEnum.ERROR:
                return 'error';
            case NoticeLevelEnum.WARNING:
                return 'warning';
            case NoticeLevelEnum.INFO:
            default:
                return 'info';
        }
    }

    noticeIcon(notice: Notice): IconEnum {
        return 'warning';
    }
}
